import {
  CircularProgress,
  LinearProgress,
  linearProgressClasses,
} from "@mui/material";
import { Logo } from "../../assets/svg/Svgs";
import { primary10 } from "../../constants/colors";

export const Loader = () => {
  return (
    <div className="flexCenter flexColumn gap20 vh100">
      <img alt="logo" src={Logo} width={50} height={50} />
      <div style={{ width: 100 }}>
        <LinearProgress
          sx={{
            borderRadius: 5,
            height: 4,
            [`& .${linearProgressClasses.bar}`]: {
              borderRadius: 5,
            },
            [`&.${linearProgressClasses.colorPrimary}`]: {
              backgroundColor: primary10,
            },
          }}
        />
      </div>
    </div>
  );
};

export const SimpleLoader = () => {
  return (
    <div className="x100 flexCenter">
      <div className="p20">
        <CircularProgress size={20} />
      </div>
    </div>
  );
};
